import { Card, Typography } from "../material-old";
import { Button, Form, FormProps, message, Select, Space } from "antd";
import React, { useEffect } from "react";
import { SaveFilled } from "@ant-design/icons";
import {
  BaseRequirementOption,
  baseRequirementTypeOptions,
} from "./fixtures/baseRequirementTypeOptions.ts";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import {
  fetchBaseRequirementByID,
  updateBaseRequirementByID,
} from "../../redux/actions/baseRequirementsActions.tsx";
import { CoreLoading } from "../common/CoreLoading.tsx";
import { BreadcrumbComponent } from "./BreadcrumbComponent.tsx";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

interface Props {
  id: string;
}

interface FormValues {
  name: string;
  type: BaseRequirementOption;
}

export const Edit: React.FC<Props> = ({ id }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useAppDispatch();
  const { activeRequirement, loading } = useAppSelector(
    (state) => state.baseRequirements,
  );

  useEffect(() => {
    handleInitializeRequirementForm();
  }, [id]);

  const handleInitializeRequirementForm = async () => {
    try {
      const req = await dispatch(fetchBaseRequirementByID(id)).unwrap();

      if (req) {
        form.setFieldsValue({
          name: req.name,
          type: req.type,
        });
      }
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo cargar el requisito."));
    }
  };

  const handleResetForm = () => form.resetFields();

  const handleSubmitForm: FormProps<FormValues>["onFinish"] = async (
    values,
  ) => {
    try {
      await dispatch(
        updateBaseRequirementByID({
          id: id,
          name: values.name,
          type: values.type,
        }),
      ).unwrap();

      messageApi.open({
        type: "success",
        content: "Requisito actualizado.",
      });
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo actualizar el requisito."));
    }
  };

  if (!activeRequirement || loading) return <CoreLoading size={1} />;

  const { name } = activeRequirement;

  return (
    <Card className="mx-auto py-8 px-20 md:w-8/12">
      {contextHolder}
      <div className="flex justify-end">
        <BreadcrumbComponent pathText={name} />
      </div>
      <div className="text-center mt-4">
        <Space>
          <Typography variant="h5" color="blue-gray">
            {name}
          </Typography>
        </Space>
      </div>
      <hr className="mt-4" />
      <div className="text-sm mt-8 flex flex-col w-full">
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={handleSubmitForm}
        >
          {/*<Form.Item<FormValues> name="name" label="Nombre" rules={[{required: true}]}>
            <Input/>
          </Form.Item>*/}
          <Form.Item<FormValues>
            name="type"
            label="Tipo"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Selecciona un tipo"
              onChange={undefined}
              allowClear
            >
              {baseRequirementTypeOptions.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SaveFilled />}
              >
                Guardar
              </Button>
              <Button htmlType="button" onClick={handleResetForm}>
                Restablecer
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </Card>
  );
};
